import CartOverview from "containers/CartOverview/CartOverview";
import Checkout from "containers/Checkout/Checkout";
import Home from "containers/Home/Home";
import UserDetails from "containers/UserDetails/UserDetails";
import VendingMachineDispense from "containers/VendingMachineDispense/VendingMachineDispense";
import VerifyOtp from "containers/VerifyOtp/VerifyOtp";
import LoginForm from "components/LoginForm/LoginForm";
import DispenseLater from "containers/DispenseLater/DispenseLater";
//Defines total pages we will be showing in our app
export const APP_ROUTES = {
  LOGIN: { url: "/loginform", component: LoginForm },
  DISPENSE_LATER: { url: "/despense_later", component: DispenseLater },
  USERDETAILS: { url: "/user-details", component: UserDetails },
  HOME_PAGE: { url: "/", component: Home },
  CART_PAGE: { url: "/cart", component: CartOverview },
  CHECKOUT_PAGE: { url: "/checkout", component: Checkout },
  DISPENSING_ITEMS: {
    url: "/vending-machine-dispense/:orderId/:cartId",
    rawUrl: "/vending-machine-dispense/",
    component: VendingMachineDispense,
  },
};
